export const showLoader = (selector, show = true) => {
    if(show){
        $(selector).css("display", "flex");
    } else{
        $(selector).css("display", "none");
    }
}